export default "__VITE_ASSET__Bg1LYRWp__"